export default "__VITE_ASSET__DKhknT3y__"